import { ADDON_PRODUCT_STORAGE_TYPES } from "@stores/addons/constants";
import { anyOf, IFlatAddOnDescriptor } from "../types";
import { areConnectionsAllowed } from "@stores/config/utils";

const etlConnections = {
  productType: "etl-connections",
  kind: "flat",
  title: "ETL Connections",

  requires: anyOf(ADDON_PRODUCT_STORAGE_TYPES),
  getBillingRowItem: () => ({}),
  getUpsertAddOns: ({ config }) => {
    return areConnectionsAllowed(config)
      ? [{ product_type: "etl-connections", prepaid_units: 1 }]
      : [];
  },
} satisfies IFlatAddOnDescriptor;

export default etlConnections;
